import { cn } from "cn"
import { type Variants } from "motion/react"

import { useTranslation } from "@/lib/i18n/i18n-context"
import { NO_TRANSLATE } from "@/lib/weglot"
import { CarouselDots } from "@/components/carousel-dots"
import IconChevronLeft from "@/components/icons/chevron-left"
import IconChevronRight from "@/components/icons/chevron-right"
import { IconButton } from "@/components/ui/icon-button"

export const MARKETING_CAROUSEL_IN_VIEW_OPTIONS = {
  triggerOnce: true,
  threshold: 0.4,
}

export const MARKETING_CAROUSEL_CONTAINER_VARIANTS: Variants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.12, delayChildren: 0.08 },
  },
}

export const MARKETING_CAROUSEL_ITEM_VARIANTS: Variants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
}

export function MarketingCarouselControls({
  pages,
  activePageIndex,
  goTo,
  prev,
  next,
  arrowClassName = "top-1/2 -translate-y-1/2 -mt-4",
}: {
  pages: number[][]
  activePageIndex: number
  goTo: (pageIndex: number) => void
  prev: () => void
  next: () => void
  arrowClassName?: string
}) {
  const t = useTranslation()
  if (pages.length <= 1) return null

  return (
    <>
      <CarouselDots
        numberOfDots={pages.length}
        activeDotIndex={activePageIndex}
        onDotClick={goTo}
        className="mt-7"
      />
      <div
        className={cn(
          "absolute left-2.5 hidden opacity-0 transition-opacity group-hover/carousel:opacity-100 can-hover:block",
          arrowClassName,
          activePageIndex === 0 && "pointer-events-none opacity-0!"
        )}
      >
        <IconButton
          size="md"
          icon={IconChevronLeft}
          variant="primary"
          label={t("previous")}
          className={NO_TRANSLATE}
          onClick={prev}
        />
      </div>
      <div
        className={cn(
          "absolute right-2.5 hidden opacity-0 transition-opacity group-hover/carousel:opacity-100 can-hover:block",
          arrowClassName,
          activePageIndex === pages.length - 1 &&
            "pointer-events-none opacity-0!"
        )}
      >
        <IconButton
          size="md"
          icon={IconChevronRight}
          variant="primary"
          label={t("next")}
          className={NO_TRANSLATE}
          onClick={next}
        />
      </div>
    </>
  )
}
